<template>
  <div>
    <vue-position-sticky>
    <div class="controlSidebar list-group">
      <a href="#" class="list-group-item active">
        Типы полей
      </a>
      <div id="sidebarControls" class="d-flex">
        <a
          href="javascript:void(0)"
          class="list-group-item list-group-item-action control-wrapper"
          v-for="(obj, value) in controls"
          :data-control-type="value"
          :key="value"
        >
          <font-awesome-icon :icon="obj.icon"></font-awesome-icon>
          {{ obj.label }}
        </a>
      </div>
    </div>
</vue-position-sticky>
    <div class="modal" id="controlConfigModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="controlInfo !== null">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">Настройки - {{ controlInfo.label }}</h4>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <base-config-component
              :control="controlInfo"
            ></base-config-component>
            <component
              v-if="configComponent != null"
              :is="configComponent"
              :control="controlInfo"
            ></component>
            <base-style-component :control="controlInfo"></base-style-component>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button class="btn btn-primary" @click="applyEditSidebar">
              Применить
            </button>
            <button class="btn btn-secondary" @click="closeEditSidebar">
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CONTROL_TYPES } from '../../config/control_constant';
import {
  eventBus,
  EventHandlerConstant
} from '../../template/handler/event_handler';
import { ControlHandler } from '../../template/handler/control_handler';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Hooks } from '../../template/components/hook_lists';
import BaseConfigComponent from './sidebar_items/BaseConfigComponent';
import BaseStyleComponent from './sidebar_items/BaseStyleComponent';

export default {
  components: { BaseStyleComponent, BaseConfigComponent, FontAwesomeIcon },
  name: 'sidebar-component',
  data: () => ({
    controls: CONTROL_TYPES,
    controlInfo: null,
    configComponent: null
  }),
  methods: {
    closeEditSidebar() {
      $('#controlConfigModal').modal('hide');
      this.controlInfo = null;
      ControlHandler.clearSelect();
    },
    applyEditSidebar() {
      if (this.controlInfo.name !== ControlHandler.getSelectedItem()) {
        return;
      }

      // before hook here
      let b4Run = Hooks.Sidebar.beforeApplyConfig.runSequence(this.controlInfo);
      if (b4Run === false) {
        return;
      }

      eventBus.$emit(
        EventHandlerConstant.ON_APPLY_EDITOR_SIDEBAR,
        this.controlInfo
      );

      // after hook here
      Hooks.Sidebar.afterApplyConfig.run(this.controlInfo);
      this.closeEditSidebar();
    }
  },
  created() {
    // catch event activate sidebar here
    eventBus.$on(EventHandlerConstant.ACTIVATE_EDITOR_SIDEBAR, controlInfo => {
      // before hook here
      let b4Run = Hooks.Sidebar.beforeOpenConfig.runSequence(controlInfo);
      if (b4Run === false) {
        return;
      }

      // open config
      this.controlInfo = controlInfo;
      this.configComponent = null;

      $('#controlConfigModal').modal('show');

      // retrieve config component
      if (_.accessStr(this.controls[controlInfo.type], 'source.config')) {
        this.configComponent = this.controls[controlInfo.type].source.config;
      }

      // after hook here
      Hooks.Sidebar.afterOpenConfig.run(this.controlInfo);
    });
  },
  mounted() {
    // insert controls
    $('.list-group-item', $('#sidebarControls')).draggable({
      appendTo: 'body',
      containment: '',
      scroll: false,
      helper: 'clone',
      revert: true,
      zIndex: 9999,
      cancel: '.list-group-item-success',
      start: function(event, ui) {
        $(ui.helper).css('width', `${$(event.target).width()}px`);
      }
    });

    $(this.$el)
      .find('.controlSidebar')
      .droppable({
        accept: '.controlItemWrapper',
        drop: function(event, ui) {
          // remove control
          eventBus.$emit(EventHandlerConstant.REMOVE_CONTROL, ui);
        },
        over: function(event, ui) {
          ui.helper.css('border', '1px solid red');
        }
      });
  }
};
</script>

<style scoped></style>
